import { mergePathConfig } from 'src/navigation/linking/utils';
export const reviewPipelineStackLinking = {
    screens: {
        RP_Home: {
            path: 'review-pipeline/*',
            ...mergePathConfig(['filters'], ['tabID']),
        },
        RP_ReviewDetails: {
            path: 'review-pipeline/details/:reviewEntityID',
        },
    },
};
